enum DriverAddCarOwnershipType {
  OWNER = "OWNER",
  BUSINESS = "BUSINESS",
}

export default DriverAddCarOwnershipType;
